export default __webpack_public_path__ + "static/media/image-block-thumbnail-light.24417dbe.svg";